import {inject, Injectable} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {Subscription} from 'rxjs';

// TODO reuse for header component

@Injectable({providedIn: 'root'})
export class TranslocoTranslationService {
  private readonly transloco = inject(TranslocoService);

  handleLanguageChange(
    langSubscription: Subscription,
    translateAttributes: (lang: string) => void,
  ): Subscription {
    this.removeLanguageSubscription(langSubscription);
    return this.transloco.langChanges$.subscribe(() => {
      this.translateForActiveLanguage(translateAttributes);
    });
  }

  removeLanguageSubscription(langSubscription: Subscription) {
    if (langSubscription) {
      langSubscription.unsubscribe();
    }
  }

  translateForActiveLanguage(translateAttributes: (lang: string) => void) {
    const lang = this.transloco.getActiveLang();
    this.transloco.load(lang).subscribe(() => translateAttributes(lang));
  }
}
